import { output } from '@b2b/types/core';
import angular from 'angular';
import { TabPanelComponentModule } from './tab-panel.component';
import { TabComponentModule, TabController } from './tab.component';
import { TabsWidgetComponentModule } from './tabs-widget.component';

class TabsController {
  static $inject = ['$element'];
  private tabs: TabController[] = [];
  private selectedTab: TabController | null = null;
  selectedTabChange = output<{ tab: TabController }>();

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-tabs');
  }

  registerTab(tab: TabController) {
    this.tabs.push(tab);

    if (!this.selectedTab && this.tabs.length > 0) {
      this.selectTab(this.tabs[0]);
    }
  }

  selectTab(selectedTab: TabController) {
    let foundTab: TabController | null = null;

    this.tabs.forEach(function (tab) {
      // Makes sure all other tabs are unselected
      if (tab !== selectedTab) {
        tab.selected = false;
        tab.$element.removeClass('active');
        return;
      }

      tab.selected = true;
      tab.$element.addClass('active');

      foundTab = tab;
    });

    // Prevents a new tab change event when user selects the same tab instance
    if (foundTab && foundTab !== this.selectedTab) {
      this.selectedTab = foundTab;
      this.selectedTabChange({ $event: { tab: this.selectedTab } });
    }
  }
}

export const TabsComponentModule = angular
  .module('acme.common.component.tabs', [TabComponentModule, TabPanelComponentModule, TabsWidgetComponentModule])
  .component('acmeTabs', {
    templateUrl: 'common/components/tabs/tabs.component.tpl.html',
    controller: TabsController,
    transclude: {
      tabs: '?acmeTab',
      panels: '?acmeTabPanel',
      widget: '?acmeTabsWidget',
    },
    bindings: {
      selectedTabChange: '&',
    },
  }).name;
